const wageData = require("../../../db/wage.json");
const labourData = require("../../../db/labour.json");

// 定員人数によってjson keyを所得
function convert(num) {
  if (num < 26) {
    return "num25"
  } else if (num >= 26 && num < 51) {
    return "num26_50"
  } else if (num >= 51 && num < 81) {
    return "num51_80"
  } else if (num >= 81 && num < 101) {
    return "num81_100"
  } else if (num >= 101 && num < 151) {
    return "num101_150"
  } else if (num >= 151 && num < 201) {
    return "num151_200"
  }

  throw new Error("定員超え");
}


// checkboxのcheckが入った値を所得
function getCheckedItems(checkboxes) {
  const items = [];
  for (const checkbox of Array.from(checkboxes)) {
    if (checkbox.checked) {
      items.push(checkbox.value);
    }
  }

  return items;
}

// inputの値から時給を所得
function getWageByPref(id) {
  let wage;

  const wageArray = Array.from(JSON.parse(JSON.stringify(wageData)));

  for (const pref of wageArray) {
    if (pref.id === id && "wage" in pref) wage = pref.wage;
  }

  return wage;
}

// 都道府県IDから社員給与を取得
function getEmployeeSalaryByPref(id, options = [], capacity = null) {
  let salary;

  const employeeSalaryArray = Array.from(JSON.parse(JSON.stringify(labourData.employeeSalary)));

  for (const pref of employeeSalaryArray) {
    if (pref.id === id) {
      // オプション判定
      const hasOperationManagement = options.indexOf("operation-management") >= 0;
      const hasFoodService = options.indexOf("food-service") >= 0;

      // 定員区分判定
      const isUnder100 = capacity === "num25" || capacity === "num26_50" || capacity === "num51_80" || capacity === "num81_100";
      const isUnder150 = isUnder100 || capacity === "num101_150";
      const is151Plus = capacity === "num151_200";

      // 新しい条件判定
      let usePriceAndWife = false;
      let logMessage = "";

      // 仕様:
      // - 0〜25人は price のみ
      // - 26〜100人で運営管理のみは price のみ
      // - 100人超はどの条件でも price_and_wife
      // - 上記以外は price_and_wife

      const isNum25 = capacity === "num25";
      const is26to100 = capacity === "num26_50" || capacity === "num51_80" || capacity === "num81_100";
      const is100Plus = capacity === "num101_150" || capacity === "num151_200";

      if (isNum25) {
        usePriceAndWife = false;
        logMessage = `【人件費】社員（0〜25人：price）：`;
      } else if (is26to100 && hasOperationManagement && !hasFoodService) {
        usePriceAndWife = false;
        logMessage = `【人件費】社員（26〜100人+運営管理のみ：price）：`;
      } else if (is100Plus) {
        usePriceAndWife = true;
        logMessage = `【人件費】社員（101人以上：price_and_wife）：`;
      } else {
        usePriceAndWife = true;
        logMessage = `【人件費】社員（その他：price_and_wife）：`;
      }

      if (usePriceAndWife && "price_and_wife" in pref) {
        salary = pref.price_and_wife;
      } else if ("price" in pref) {
        salary = pref.price;
      }
      break;
    }
  }

  return salary;
}

// 都道府県IDに基づいてパートタイム時給を取得
function getPartTimehourlyWageByPref(id) {
  let hourlyWage = 0;

  if ("employeeSalary" in labourData) {
    for (const pref of labourData.employeeSalary) {
      if (pref.id === id) {
        hourlyWage = pref.partTimehourlyWage;
        break;
      }
    }
  }

  return hourlyWage;
}

// 必須項目の値があるかを確認
function checkFields(inputs) {
  const allValuesSet = Object.keys(inputs).every(input => {
    if (input === "options") {
      return inputs[input].length > 0;
    }
    if (input === "prefId") {
      return true; // prefIdはnullでも許可
    }
    return inputs[input];
  })

  return allValuesSet;
}

// optionsのインプットから委託内容のKEYを所得
function getKeyByOptions(options) {

  if (options.indexOf("operation-management") >= 0 && options.indexOf("food-service") >= 0) {
    return "ab";
  } else if (options.indexOf("operation-management") >= 0) {
    return "b";
  } else if (options.indexOf("food-service") >= 0) {
    return "a";
  }
}


module.exports = {
  convert,
  getCheckedItems,
  getWageByPref,
  getEmployeeSalaryByPref,
  getPartTimehourlyWageByPref,
  checkFields,
  getKeyByOptions
}
